import React, { Component } from 'react';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, Dropdown } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Translate, Localize, I18n } from 'react-redux-i18n';

import { DEFAULT_ERROR, UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import { MFG_ORDER_UPLOAD, RECEIVE_DISPATCH_URL } from '../../actions/url';
import { omit } from 'lodash';
const AutoCompleteEditor = Editors.AutoComplete;
class SetDispatchLocationModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      rows: [],
      selectedRow: {},
      isLoading: false,
      receive_file_name: '',
      receive_file_url: '',
    }
  }


  componentDidMount() {
    const { receive_file_url, receive_file_name } = this.props.receiveDetails;
    this.setState({
      rows: this.props.rows.map(row => ({
        ...row,
        ExcellentQuantity: row.ExcellentQuantity === null ? row.RcvQuantity : row.ExcellentQuantity,
        DefectiveQuantity: row.DefectiveQuantity === null ? 0 : row.DefectiveQuantity,
        ConcessionQuantity: row.ConcessionQuantity === null ? 0 : row.ConcessionQuantity,
        location: row.zone_num,
        // qualifiedRows: isEmpty(row.location_json_excellent)
        //   ? []
        //   : JSON.parse(row.location_json_excellent).map((json, index) => ({
        //     Idx: index + 1,
        //     quantity: row.ProductType === 'Fixed' ? json.quantity : json.net_weight,
        //     location: json.zone_num,
        //   })),
        // unqualifiedRows: isEmpty(row.location_json_defective)
        //   ? []
        //   : JSON.parse(row.location_json_defective).map((json, index) => ({
        //     Idx: index + 1,
        //     quantity: row.ProductType === 'Fixed' ? json.quantity : json.net_weight,
        //     location: json.zone_num,
        //   })),
      })),
      receive_file_name,
      receive_file_url,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      this.setState({
        rows: nextProps.rows.map(row => ({
          ...row,
          ExcellentQuantity: row.ExcellentQuantity === null ? row.RcvQuantity : row.ExcellentQuantity,
          DefectiveQuantity: row.DefectiveQuantity === null ? 0 : row.DefectiveQuantity,
          ConcessionQuantity: row.ConcessionQuantity === null ? 0 : row.ConcessionQuantity,
          location: row.zone_num,
          // qualifiedRows: isEmpty(row.location_json_excellent)
          //   ? []
          //   : JSON.parse(row.location_json_excellent).map((json, index) => ({
          //     Idx: index + 1,
          //     quantity: row.ProductType === 'Fixed' ? json.quantity : json.net_weight,
          //     location: json.zone_num,
          //   })),
          // unqualifiedRows: isEmpty(row.location_json_defective)
          //   ? []
          //   : JSON.parse(row.location_json_defective).map((json, index) => ({
          //     Idx: index + 1,
          //     quantity: row.ProductType === 'Fixed' ? json.quantity : json.net_weight,
          //     location: json.zone_num,
          //   })),
        }))
      });
    }
    if (nextProps.receiveDetails && nextProps.receiveDetails !== this.props.receiveDetails) {
      const { receive_file_url, receive_file_name } = nextProps.receiveDetails;
      this.setState({
        receive_file_url,
        receive_file_name,
      })
    }
  }

  renderProductTable = () => {
    const IsFixedFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.ProductType === "Non-Fixed") {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
        } else {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value}</span>;
        }
      }
    });
    const {qualifiedLocationOptions} = this.props;
    const qualifiedLocationOptionsData = I18n._locale === 'ch'
      ? qualifiedLocationOptions.map(item => ({id: item.value, title: item.text}))
      : qualifiedLocationOptions.map(item => ({
        id: item.value,
        title: item.value
      }))
    const columns = [{
      key: 'ProductNum',
      name: <Translate value="prod_num" />,
      resizable: true,
      sortable: true,
      width: 65,
      filterable: true,
    }, {
      key: 'ProductName',
      name: <Translate value="prod_name" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    }, {
      key: 'ProductRefNum',
      name: <Translate value="ref_num" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    }, {
      key: 'PackageSize_1',
      name: <Translate value="package_size" />,
      resizable: true,
      sortable: true,
      width: 85,
      filterable: true
    }, {
      key: 'RcvQuantity',
      name: <Translate value="rcv_qty" />,
      resizable: true,
      editable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: IsFixedFormatter,
      getRowMetaData: (row) => row,
    }, {
      key: 'RcvTotalWeight',
      name: <Translate value="rcv_weight" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: IsFixedFormatter,
      getRowMetaData: (row) => row,
    }, {
      name: <Translate value="qc_status"/>,
      resizable: true,
      width: 150,
      getRowMetaData: row => row,
      formatter: ({ value, dependentValues }) => {
        if (dependentValues.DefectiveQuantity !== null && dependentValues.DefectiveQuantity !== undefined && dependentValues.DefectiveQuantity !== '') {
          return <div>{dependentValues.ExcellentQuantity + ' / ' + dependentValues.ConcessionQuantity + ' / ' + dependentValues.DefectiveQuantity}</div>
        }
        return <div />
      }
    }, {
      key: 'location',
      name: <Translate value="location" />,
      resizable: true,
      sortable: true,
      width: 130,
      editable: true,
      editor: <AutoCompleteEditor
        options={qualifiedLocationOptionsData}
        valueParams={['id']}
        editorDisplayValue={(column, value) => {
          const option = column.editor.props.options.find(option => option.id === value);
          return option ? option.title : value
        }}
      />,
      formatter: ({value}) => {
        const option = this.props.qualifiedLocationOptions.find(option => option.value === value);
        if (option) {
          return <span>{I18n._locale === 'ch' ? option.text : option.value}</span>
        }
        return <span />
      }
    },{
      key: 'Remark',
      name: <Translate value="remark" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true
    }];
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    }
    const onRowsSelected = (rows) => {
      let newRows = this.state.rows.map(row => ({...row, isSelected: false}));
      rows.map (r => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({rows: newRows, selectedRow: {...rows[0].row, rowIdx: rows[0].rowIdx, isSelected: true}});
    }

    const onRowsDeselected = (rows) => {
      let newRows = this.state.rows;
      rows.map (r => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({rows: newRows, selectedRow: {}});
    }
    const handleRowUpdated = e => {
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      this.setState({
        rows: [...rows],
      });
    }
    return <ReactDataGrid
      rowKey='WarehouseReceiveLine_id'
      columns={columns}
      enableCellSelect={true}
      rowGetter={rowGetter}
      headerRowHeight={45}
      rowHeight={35}
      minHeight={400}
      rowsCount={getSize()}
      onRowClick={(index, row) => {
        onRowsSelected([{rowIdx: index, row: {...row, rowIdx: index}}]);
      }}
      onRowUpdated={handleRowUpdated}
      // rowSelection={{
      //   showCheckbox: true,
      //   enableShiftSelect: false,
      //   onRowsSelected,
      //   onRowsDeselected,
      //   selectBy: {
      //     isSelectedKey: 'isSelected'
      //   }
      // }}
    />
  }
  renderQualifiedTable = () => {
    const getRows = () => {
      return Data.Selectors.getRows({rows: this.state.selectedRow.qualifiedRows});
    }

    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
    }
    const handleRowUpdated = e => {
      let rows = this.state.selectedRow.qualifiedRows;
      Object.assign(rows[e.rowIdx], e.updated);
      this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
      this.setState({
        selectedRow: {...this.state.selectedRow},
        rows: [...this.state.rows],
      });
    }

    const getMaxAvailableQty = () => this.state.selectedRow.ExcellentQuantity - this.state.selectedRow.qualifiedRows.reduce((max, row) => max + +row.quantity, 0);
    const handleAddRow = () => {
      let rows = this.state.selectedRow.qualifiedRows;
      const maxAvailableQty = getMaxAvailableQty();
      if (maxAvailableQty > 0) {
        rows.push({Idx: rows.length + 1, quantity: maxAvailableQty, location: ''})
        this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
        this.setState({
          selectedRow: {...this.state.selectedRow},
          rows: [...this.state.rows],
        });
      }
    }
    const handleRemoveRow = idx => {
      let rows = this.state.selectedRow.qualifiedRows;
      rows.splice(idx, 1);
      this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
      this.setState({
        rows: [...this.state.rows],
        selectedRow: {...this.state.selectedRow},
      });
    }
    const IsVariableFormatter = React.createClass({
      render() {
        return <span>
          <Button
            bsStyle="danger"
            className="textAlignStyle"
            style={{ height: '23px', width: '39px', padding: '0px' }}
            onClick={ () => { handleRemoveRow(this.props.dependentValues.rowIdx) } }
          >
            <Translate value="X" />
          </Button>
        </span>;
      }
    });
    const columns = [
      {
        key: 'Delete',
        name: <Translate value="del" />,
        formatter: IsVariableFormatter,
        width: 50,
        getRowMetaData: (row) => row
      },
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: true,
      },
      {
        key: 'quantity',
        name: <Translate value="qty" />,
        resizable: true,
        editable: false,
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        editable: true,
        editor: <AutoCompleteEditor options={this.props.qualifiedLocationOptions} valueParams={['id']}/>,
        formatter: ({value}) => {
          if (value) {
            const option = this.props.qualifiedLocationOptions.find(option => option.value === value);
            return <span>{option.text}</span>
          }
          return <span />
        }
      },
    ];
    return <div>
      <Row>
        <Col sm={12} style={{padding: '0px', marginBottom: '10px'}}>
          <Button onClick={handleAddRow}><i className="fa fa-plus" /> <Translate value="create" /></Button>
          {!isEmpty(this.state.selectedRow) && <span style={{marginLeft: '20px', fontWeight: 'bold'}}>{getMaxAvailableQty()} <Translate value="left" /></span>}
        </Col>
      </Row>
      <Row>
        <Col sm={12} style={{padding: '0px'}}>
          <ReactDataGrid
            rowKey='BatchNum'
            style={{ height: '10%' }}
            columns={columns}
            enableCellSelect
            rowHeight={35}
            minHeight={200}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            onRowUpdated={handleRowUpdated}
          />
        </Col>
      </Row>
    </div>
  }
  renderUnqualifiedTable = () => {
    const getRows = () => {
      return Data.Selectors.getRows({rows: this.state.selectedRow.unqualifiedRows});
    }

    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
    }
    const handleRowUpdated = e => {
      let rows = this.state.selectedRow.unqualifiedRows;
      Object.assign(rows[e.rowIdx], e.updated);
      this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
      this.setState({
        selectedRow: {...this.state.selectedRow},
        rows: [...this.state.rows],
      });
    }

    const getMaxAvailableQty = () => this.state.selectedRow.unqualified - this.state.selectedRow.unqualifiedRows.reduce((max, row) => max + +row.quantity, 0);
    const handleAddRow = () => {
      let rows = this.state.selectedRow.unqualifiedRows;
      const maxAvailableQty = getMaxAvailableQty();
      if (maxAvailableQty > 0) {
        rows.push({Idx: rows.length + 1, quantity: maxAvailableQty, location: ''})
        this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
        this.setState({
          selectedRow: {...this.state.selectedRow},
          rows: [...this.state.rows],
        });
      }
    }
    const handleRemoveRow = idx => {
      let rows = this.state.selectedRow.unqualifiedRows;
      rows.splice(idx, 1);
      this.state.rows[this.state.selectedRow.rowIdx] = this.state.selectedRow;
      this.setState({
        rows: [...this.state.rows],
        selectedRow: {...this.state.selectedRow},
      });
    }
    const IsVariableFormatter = React.createClass({
      render() {
        return <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={ () => { handleRemoveRow(this.props.dependentValues.rowIdx) } }
              >
                  <Translate value="X" />
              </Button>
            </span>;
      }
    });
    const columns = [
      {
        key: 'Delete',
        name: <Translate value="del" />,
        formatter: IsVariableFormatter,
        width: 50,
        getRowMetaData: (row) => row
      },
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: true,
      },
      {
        key: 'quantity',
        name: <Translate value="qty" />,
        resizable: true,
        editable: true,
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        editable: true,
        editor: <AutoCompleteEditor options={this.props.unqualifiedLocationOptions} valueParams={['id']}/>,
        formatter: ({value}) => {
          if (value) {
            const option = this.props.unqualifiedLocationOptions.find(option => option.value === value);
            return <span>{option.text}</span>
          }
          return <span />
        }
      },
    ];
    return <div style={{marginLeft: '10px'}}>
      <Row>
        <Col sm={12} style={{padding: '0px', marginBottom: '10px'}}>
          <Button onClick={handleAddRow}><i className="fa fa-plus" /> <Translate value="create" /></Button>
          {!isEmpty(this.state.selectedRow) && <span style={{marginLeft: '20px', fontWeight: 'bold'}}>{getMaxAvailableQty()} <Translate value="left" /></span>}
        </Col>
      </Row>
      <Row>
        <Col sm={12} style={{padding: '0px'}}>
          <ReactDataGrid
            style={{ height: '10%' }}
            columns={columns}
            enableCellSelect
            rowHeight={35}
            minHeight={200}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            onRowUpdated={handleRowUpdated}
          />
        </Col>
      </Row>
    </div>
  }
  renderFileUpload = () => {
    const { receive_file_url, receive_file_name } = this.state;
    const hasFile = receive_file_name && receive_file_url;
    const styles = {
      container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      uploaderWrapper: {
        width: '100%',
        height: '60px',
        border: '1px solid #000000',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '10px auto'
      },
      uploader: {
        width: '100%',
        height: '100%',
        opacity: 0,
        position: 'absolute',
        zIndex: '100',
      },
      uploadIcon: {
        fontSize: '44px',
        color: '#000000',
      }
    }
    const handleUpload = ({target: {files}}) => {
      const data = new FormData();
      data.append('File', files[0]);
      this.setState({
        isLoading: true,
      })
      axios.post(MFG_ORDER_UPLOAD, data, {headers: { 'Content-Type': 'multipart/form-data' }}).then(response => {
        if (response.data.url) {
          const receive_file_url = response.data.url;
          const receive_file_name = files[0].name;
          this.setState({
            rows: [...this.state.rows],
            receive_file_url,
            receive_file_name
          })
        }
      }).finally(() => this.setState({isLoading: false}));
    }
    const handleDownload = () => {
      window.open(receive_file_url);
    }
    const handleRemove = e => {
      e.stopPropagation();
      this.setState({
        rows: [...this.state.rows],
        receive_file_url: '',
        receive_file_name: '',
      })
    }
    if (hasFile) {
      return <Col sm={4}>
        <Row onClick={handleDownload}>
          <Col sm={12}>
            <Row style={{marginTop: '10px'}}>
              <Col sm={2}><i className="fa fa-file" style={{fontSize: '20px'}}/></Col>
              <Col sm={9}>{receive_file_name}</Col>
              <Col sm={1} onClick={handleRemove}><i className="fa fa-remove" /></Col>
            </Row>
          </Col>
        </Row>
      </Col>
    }
    return <div id="uploaderWrapper" style={styles.uploaderWrapper}>
        {this.state.isLoading
          ? <Spinner className="marginTopStyle" />
          : <div style={omit(styles.uploaderWrapper, ['border', 'margin'])}>
            <i className={'fa fa-upload'} style={styles.uploadIcon}/>
            <input type={'file'} style={styles.uploader} onChange={handleUpload} />
          </div>}
      </div>
  }
  handleSaveClick = () => {
    const receiveId = this.props.receiveDetails.WarehouseReceive_id;
    axios.put(`${RECEIVE_DISPATCH_URL}${receiveId}/`, {
      divide_data_list: this.state.rows.map(row => ({
        ...row,
        zone_num: row.location,
        // location_json_excellent: JSON.stringify(row.qualifiedRows.map(qualifiedRow => ({
        //   zone_num: qualifiedRow.location,
        //   ...(row.ProductType === 'Fixed'
        //     ? {quantity: qualifiedRow.quantity}
        //     : {net_weight: qualifiedRow.quantity}
        //   )
        // }))),
        // location_json_defective: JSON.stringify(row.unqualifiedRows.map(unqualifiedRow => ({
        //   zone_num: unqualifiedRow.location,
        //   ...(row.ProductType === 'Fixed'
        //       ? {quantity: unqualifiedRow.quantity}
        //       : {net_weight: unqualifiedRow.quantity}
        //   )
        // })))
      })),
      receive_file_name: this.state.receive_file_name,
      receive_file_url: this.state.receive_file_url,
    }, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      alert('Location successfully updated!');
      this.props.onClose(true);
    }).catch(err => {
      alert(err.data || DEFAULT_ERROR);
    })
  }
  render() {

    return (
      <ContentWrapper>
        <hr />
        {this.renderProductTable()}
        <br />
        <Col sm={12}>
          {/* {this.renderQualifiedTable()} */}
        </Col>
        {/* <Col sm={6}> */}
        {/*   {this.renderUnqualifiedTable()} */}
        {/* </Col> */}
        <Row style={{marginTop: '10px'}}>
          <Col sm={6}>
            <Col sm={6}>
              <label><Translate value="report_file" /></label>
            </Col>
          </Col>
        </Row>
        <Row>
          {this.renderFileUpload()}
        </Row>
        <Row>
          <Col sm={6}>
            <button
              className="btn btn-primary col-sm-11 buttonStyle"
              onClick={this.handleSaveClick}
            >
              <Translate value="save" />
            </button>
          </Col>
          <Col sm={6}>
            <button className="btn btn-danger col-sm-11 buttonStyle" onClick={() => {this.props.onClose()}}>
              <Translate value="cancel" />
            </button>
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default SetDispatchLocationModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/setDispatchLocationModal.jsx